import React, { useState, useEffect } from 'react';
import Flag from 'react-world-flags';
import { BsDiscord } from 'react-icons/bs';
import { FaUsers } from 'react-icons/fa';

function getSteamConnect(ip, port) {
  return 'https://ohdservers.net/launcher/' + ip + ':' + port;
}

function getDiscordLink(serverName) {
  const patterns = [
    { regex: /discord\.gg\/([^\s]+)/, base: 'https://discord.gg/' },
    { regex: /DSC\.GG\/([^\s]+)/i, base: 'https://dsc.gg/' },
    { regex: /discord\.me\/([^\s]+)/, base: 'https://discord.me/' },
    { regex: /dsc\.gg\/([^\s]+)/i, base: 'https://dsc.gg/' },
  ];

  for (const p of patterns) {
    const match = serverName.match(p.regex);
    if (match) return p.base + match[1];
  }

  if (serverName.includes('jpnhq.net')) return 'https://discord.jpnhq.net';
  if (serverName.includes('RustyRifles')) return 'http://rustyrifles.uk';
  if (serverName.includes('LoyalGames.Eu')) return 'http://discord.loyalgames.eu/';
  if (serverName.includes('preunk.com/discord')) return 'https://preunk.com/discord';

  return null;
}

function getVersion(gametype) {
  try {
    return gametype.split(':')[1];
  } catch {
    return 'Unknown';
  }
}

function getPlayerStatus(players, maxPlayers) {
  const ratio = players / maxPlayers;
  if (ratio >= 0.8) return { label: 'FULL', color: '#ef4444' };
  if (ratio >= 0.5) return { label: 'BUSY', color: '#fbbf24' };
  if (players > 0) return { label: 'OPEN', color: '#22c55e' };
  return { label: 'EMPTY', color: '#64748b' };
}

const TitleCard = (props) => {
  const { servers } = props;
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const checkWidth = () => setIsNarrow(window.innerWidth < 500);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  const colStyle = (show) => ({ display: show ? 'block' : 'none' });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <div
        className="header-row"
        style={{
          display: 'grid',
          gridTemplateColumns: '28px 2fr 1fr 80px 90px 80px 40px',
          gap: '8px',
          padding: '8px 16px',
          background: 'rgba(15, 23, 42, 0.9)',
          borderRadius: '8px 8px 0 0',
          borderBottom: '1px solid rgba(251, 191, 36, 0.2)',
          fontSize: '0.7rem',
          fontWeight: '600',
          color: '#94a3b8',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        <span></span>
        <span>Server</span>
        <span>Map</span>
        <span style={{ textAlign: 'center' }}><FaUsers style={{ marginRight: '4px' }} />Players</span>
        <span style={{ textAlign: 'center' }} className="col-ip">IP:Port</span>
        <span style={{ textAlign: 'center' }} className="col-ver">Ver</span>
        <span></span>
      </div>

      {servers.map((s, index) => {
        const discordLink = getDiscordLink(s.name);
        const playerStatus = getPlayerStatus(s.players, s.max_players);
        const isEmpty = s.players === 0;

        return (
          <div
            key={index}
            onClick={() => window.location.href = getSteamConnect(s.sip, s.gameport)}
            className="server-row"
            style={{
              cursor: 'pointer',
              display: 'grid',
              gridTemplateColumns: '28px 2fr 1fr 80px 90px 80px 40px',
              gap: '8px',
              padding: '12px 16px',
              background: isEmpty ? 'rgba(15, 23, 42, 0.3)' : 'rgba(30, 41, 59, 0.5)',
              borderRadius: '0',
              borderBottom: '1px solid rgba(255, 255, 255, 0.04)',
              opacity: isEmpty ? 0.6 : 1,
              filter: isEmpty ? 'grayscale(40%)' : 'none',
              transition: 'all 0.15s ease',
              alignItems: 'center',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(51, 65, 85, 0.7)';
              e.currentTarget.style.borderLeft = '3px solid #fbbf24';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = isEmpty ? 'rgba(15, 23, 42, 0.3)' : 'rgba(30, 41, 59, 0.5)';
              e.currentTarget.style.borderLeft = '3px solid transparent';
            }}
          >
            <Flag code={s.scountry} height="20" style={{ justifySelf: 'center' }} />

            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  color: '#f1f5f9',
                  fontWeight: '600',
                  fontSize: '0.875rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {s.name}
              </div>
              <div
                style={{
                  color: playerStatus.color,
                  fontSize: '0.7rem',
                  fontWeight: '500',
                  marginTop: '2px',
                }}
              >
                {playerStatus.label}
              </div>
            </div>

            <div
              style={{
                color: '#cbd5e1',
                fontSize: '0.8rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {s.map}
            </div>

            <div style={{ textAlign: 'center' }}>
              <span
                style={{
                  color: playerStatus.color,
                  fontWeight: '700',
                  fontSize: '0.9rem',
                }}
              >
                {s.players}
              </span>
              <span style={{ color: '#475569', fontSize: '0.75rem' }}> / </span>
              <span style={{ color: '#94a3b8', fontSize: '0.8rem' }}>
                {s.max_players}
              </span>
            </div>

            <div className="col-ip" style={{ color: '#64748b', fontSize: '0.7rem', textAlign: 'center', fontFamily: 'monospace' }}>
              {s.sip}:{s.gameport}
            </div>

            <div className="col-ver" style={{ color: '#475569', fontSize: '0.7rem', textAlign: 'center' }}>
              v{getVersion(s.gametype)}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
              {discordLink ? (
                <a
                  href={discordLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  style={{ color: '#5865F2', fontSize: '1rem' }}
                >
                  <BsDiscord />
                </a>
              ) : (
                <span style={{ color: '#334155', fontSize: '1rem' }}>
                  <BsDiscord />
                </span>
              )}
            </div>
          </div>
        );
      })}

      <style>{`
        @media (max-width: 500px) {
          .header-row, .server-row {
            grid-template-columns: 28px 2fr 1fr 80px 40px !important;
          }
          .col-ip, .col-ver {
            display: none !important;
          }
          .header-row .col-ip, .header-row .col-ver {
            display: none !important;
          }
        }
      `}</style>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '28px 2fr 1fr 80px 90px 80px 40px',
          gap: '8px',
          padding: '8px 16px',
          background: 'rgba(15, 23, 42, 0.9)',
          borderRadius: '0 0 8px 8px',
          borderTop: '1px solid rgba(255, 255, 255, 0.04)',
          fontSize: '0.7rem',
          color: '#64748b',
        }}
        className="footer-row"
      >
        <span style={{ justifySelf: 'center' }}>{servers.length} servers</span>
        <span></span>
        <span></span>
        <span></span>
        <span className="col-ip"></span>
        <span className="col-ver"></span>
        <span></span>
      </div>

      <style>{`
        @media (max-width: 500px) {
          .footer-row {
            grid-template-columns: 28px 2fr 1fr 80px 40px !important;
          }
          .footer-row .col-ip, .footer-row .col-ver {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default TitleCard;